    import React, { useState, useEffect } from 'react';
    import { getDoctorAvailability } from '../../../../services/apiService';
    import { oneKlicks } from '../../../../SDK/oneclick';

    const DoctorAvailable = ({ doctorId, available = false, data }) => {
        const [availability, setAvailability] = useState(null);
        const [error, setError] = useState(null);

        useEffect(() => {
            
            if(data){
                setAvailability(data.appointment_settings);
            }else{
                fetchAvailability();
            }
        }, [doctorId, data]);

        const fetchAvailability = async () => {
            try {
                const tableSchema = "";
                const tableName = "appointment_settings";
                const conditions = {
                    doctor_id: doctorId
                };
                const orderBy = "id DESC";
                const search = {};
                const pagination = {};
                const margedata = [];
                const availabilityData = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
                if(availabilityData.status === 200){
                    setAvailability(availabilityData.data);
                }else{
                    setAvailability(null);
                }
                console.log("DoctorAvailable availabilityData", availabilityData);
                setAvailability(availabilityData.data);
            } catch (error) {  
                console.log('Error fetching doctor availability:', error);
                setAvailability(null);
            }
        };

        const getCurrentDay = () => {
            const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
            return days[new Date().getDay()];
        };

        if (error) {
            return <div className="availability error">{error}</div>;
        }

        if (available) {
            const isCurrentDay = availability && availability.length > 0 && 
                availability[0].week_days.includes(getCurrentDay());
            return (
                <span>
                    {isCurrentDay && (
                        <>
                            <i className="ti-clipboard"></i>
                            <em className="dc-available" style={{color: isCurrentDay ? 'green' : 'red'}}>
                                {isCurrentDay ? "Available Today" : " Not Available Today"}
                            </em>
                        </>
                    )}
                </span>
            );
        }

        return availability && availability.length > 0 ? (
            (() => {
                // Merge all available days from all appointment settings
                const allWeekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                const mergedAvailableDays = new Set();
                
                // Collect all available days from all appointment settings
                availability.forEach((slot) => {
                    const availableDays = Array.isArray(slot.week_days)
                        ? slot.week_days
                        : typeof slot.week_days === "string"
                            ? slot.week_days.split(",").map(day => day.trim())
                            : [];
                    
                    availableDays.forEach(day => {
                        mergedAvailableDays.add(day.toLowerCase());
                    });
                });

                return (
                    <span style={{display: 'flex', alignItems: 'center', gap: '-2px'}}>
                        <i className="lnr lnr-clock" style={{marginRight: '-5px', marginTop: '-6px'}}></i>
                        {/* Show the merged days as a single display */}
                        <div className="doctor-availability-days" style={{ display: 'flex', listStyle: 'none', padding: 0, margin: 0 }}>
                            {allWeekDays.map((day, dayIndex) => {
                                const isAvailable = mergedAvailableDays.has(day.toLowerCase());
                                const isToday = day.toLowerCase() === allWeekDays[new Date().getDay()].toLowerCase();
                                return (
                                   <div
                                        key={dayIndex}
                                        style={{
                                            marginRight: dayIndex < allWeekDays.length - 1 ? '0px' : 0,
                                            fontWeight: isAvailable ? 'bold' : 'normal',
                                            color: isAvailable ? (isToday ? 'orange' : '#3d4461') : '#bbb',
                                            border: isToday ? '2px solid orange' : undefined,
                                             borderRadius: isToday ? '4px' : undefined,
                                            padding: isToday ? '2px 6px' : undefined,
                                            background: isToday && isAvailable ? '#fffbe6' : undefined,
                                            minWidth: '32px',
                                            textAlign: 'center'
                                        }}
                                        title={isAvailable ? (isToday ? ' Available Today' : ' Available') : ' Not Available'}
                                    >
                                        {day}
                                    </div>
                                );
                            })}
                        </div>
                    </span>
                );
            })()
        ) : (
            <span className="availability-status"><i className="lnr lnr-clock" style={{marginRight: '5px'}}></i>Not Updated</span>
        );
    };

    export default DoctorAvailable;
    
